/** Restaurant Website — Rosette Terrace · editorial hospitality fine-dining. */

export const RESTAURANT_WEBSITE_FILES = {
  'src/index.css': `@import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,300;0,9..144,400;0,9..144,500;0,9..144,600;0,9..144,700;1,9..144,300;1,9..144,400;1,9..144,500&family=Inter+Tight:wght@300;400;500;600&display=swap');

* { box-sizing: border-box; }
html { scroll-behavior: smooth; }
body {
  margin: 0;
  font-family: 'Inter Tight', system-ui, sans-serif;
  background: #F4ECE6;
  color: #2A1F1B;
  -webkit-font-smoothing: antialiased;
}
.font-editorial { font-family: 'Fraunces', Georgia, serif; font-feature-settings: 'ss01'; }
.font-body { font-family: 'Inter Tight', system-ui, sans-serif; }

@keyframes rt-breathe {
  0%, 100% { transform: translate(0,0) scale(1); opacity: 0.5; }
  50% { transform: translate(14px,-18px) scale(1.06); opacity: 0.85; }
}
@keyframes rt-rise {
  from { opacity: 0; transform: translateY(28px); }
  to { opacity: 1; transform: translateY(0); }
}
@keyframes rt-marquee {
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
}

.rt-grain {
  background-image: radial-gradient(rgba(42,31,27,0.05) 1px, transparent 1px);
  background-size: 4px 4px;
}
.rt-vertical-label {
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  letter-spacing: 0.34em;
  text-transform: uppercase;
  font-size: 10px;
  font-weight: 600;
}
.rt-chapter {
  font-family: 'Fraunces', Georgia, serif;
  font-style: italic;
  font-weight: 300;
  letter-spacing: -0.02em;
  color: #C77F88;
}
.rt-eyebrow {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.32em;
  color: #5C8F87;
}
.rt-rule {
  height: 1px;
  background: linear-gradient(to right, transparent, rgba(199,127,136,0.4), transparent);
}
.rt-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.24em;
  color: #2A1F1B;
  padding-bottom: 6px;
  border-bottom: 1px solid rgba(42,31,27,0.6);
  transition: all 0.4s ease;
}
.rt-link:hover { color: #C77F88; border-color: #C77F88; gap: 14px; }
.rt-link-soft {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.24em;
  color: #6F5D56;
  transition: all 0.4s ease;
}
.rt-link-soft:hover { color: #5C8F87; gap: 14px; }
.btn-fill {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: #2A1F1B;
  color: #F4ECE6;
  border: none;
  padding: 16px 28px;
  font-family: inherit;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.22em;
  cursor: pointer;
  transition: all 0.45s ease;
  border-radius: 0;
}
.btn-fill:hover {
  background: #C77F88;
  color: #FFF8F2;
  letter-spacing: 0.3em;
}
.btn-outline {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: transparent;
  color: #2A1F1B;
  border: 1px solid rgba(42,31,27,0.4);
  padding: 16px 28px;
  font-family: inherit;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.22em;
  cursor: pointer;
  transition: all 0.45s ease;
  border-radius: 0;
}
.btn-outline:hover { border-color: #5C8F87; color: #5C8F87; }
.rt-mark {
  background: linear-gradient(135deg, rgba(199,127,136,0.18), rgba(168,218,212,0.25));
  padding: 0 0.18em;
}
.rt-fade > * { animation: rt-rise 1s cubic-bezier(0.2, 0.7, 0.2, 1) both; }
`,

  'src/App.js': `import React from 'react';
import './index.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import FeaturedDishes from './components/FeaturedDishes';
import Experience from './components/Experience';
import MenuShowcase from './components/MenuShowcase';
import Reservation from './components/Reservation';
import Testimonials from './components/Testimonials';
import Gallery from './components/Gallery';
import Newsletter from './components/Newsletter';
import Footer from './components/Footer';

export default function App() {
  return (
    <div className="relative min-h-screen overflow-x-hidden bg-[#F4ECE6] text-[#2A1F1B]">
      <div className="pointer-events-none fixed inset-0 z-0 bg-[radial-gradient(ellipse_at_8%_4%,rgba(199,127,136,0.22)_0%,transparent_45%),radial-gradient(ellipse_at_92%_8%,rgba(92,143,135,0.18)_0%,transparent_50%),radial-gradient(ellipse_at_50%_98%,rgba(238,212,210,0.45)_0%,#F4ECE6_60%)]" />
      <div className="pointer-events-none fixed inset-0 z-0 rt-grain opacity-50" />
      <div className="pointer-events-none fixed left-[4%] top-[20%] z-0 h-80 w-80 animate-[rt-breathe_12s_ease-in-out_infinite] rounded-full bg-[#EED4D2]/55 blur-[80px]" />
      <div className="pointer-events-none fixed bottom-[8%] right-[5%] z-0 h-96 w-96 animate-[rt-breathe_15s_ease-in-out_infinite] rounded-full bg-[#A8DAD4]/35 blur-[90px]" />
      <div className="relative z-10">
        <Navbar />
        <main>
          <Hero />
          <FeaturedDishes />
          <Experience />
          <MenuShowcase />
          <Reservation />
          <Testimonials />
          <Gallery />
          <Newsletter />
        </main>
        <Footer />
      </div>
    </div>
  );
}
`,

  'src/data/restaurant.js': `export const DISHES = [
  {
    number: '01',
    name: 'Sakura Tuna Tartare',
    course: 'Small Plate',
    desc: 'Hand-cut bluefin, avocado mousse, yuzu pearls, crispy nori rice, micro shiso.',
    price: 24,
    pairing: 'Junmai Daiginjo',
    badge: "Chef's pick",
    accent: 'from-[#EED4D2] via-[#E0A4A9]/45 to-[#A8DAD4]/35',
  },
  {
    number: '02',
    name: 'Miso-Glazed Black Cod',
    course: 'Main',
    desc: 'Slow-braised in white miso, bok choy ribbons, sesame dashi reduction.',
    price: 38,
    pairing: 'Burgundy 2019',
    badge: 'Signature',
    accent: 'from-[#F5DCDF] via-[#A8DAD4]/45 to-[#E0A4A9]/40',
  },
  {
    number: '03',
    name: 'Truffle Mushroom Risotto',
    course: 'Main',
    desc: 'Forest mushrooms, aged Parmigiano, fresh herb oil, shaved black truffle.',
    price: 32,
    pairing: 'Barolo Riserva',
    badge: 'Popular',
    accent: 'from-[#EED4D2] via-[#D88F95]/35 to-[#5C8F87]/22',
  },
  {
    number: '04',
    name: 'Rose Petal Panna Cotta',
    course: 'Dessert',
    desc: 'Lychee compote, pistachio crumble, candied edible flowers, rose syrup.',
    price: 16,
    pairing: 'Sauternes 2018',
    badge: 'Finale',
    accent: 'from-[#FFF1ED] via-[#E0A4A9]/35 to-[#A8DAD4]/30',
  },
];

export const MENU_CATEGORIES = [
  { roman: 'I', name: 'Small Plates', count: 9, tag: 'Begin the evening' },
  { roman: 'II', name: 'Mains', count: 11, tag: 'Chef compositions' },
  { roman: 'III', name: 'Desserts', count: 7, tag: 'Sweet finales' },
  { roman: 'IV', name: 'Cocktails', count: 12, tag: 'Crafted to pair' },
];

export const TESTIMONIALS = [
  {
    name: 'Maya Lin',
    role: 'Food & travel · Conde Nast',
    quote: 'The most romantic rooftop dining in the city — every plate looks like it belongs on your feed and tastes even better.',
    rating: 5,
  },
  {
    name: 'James Okonkwo',
    role: 'Eater senior contributor',
    quote: 'Rosette Terrace nails modern hospitality. Warm, aesthetic, and genuinely delicious from first bite to last sip.',
    rating: 5,
  },
  {
    name: 'Elena Vasquez',
    role: 'OpenTable diner',
    quote: 'Cozy luxury at its finest. The blush-and-teal ambiance alone makes you want to stay all evening.',
    rating: 5,
  },
];

export const GALLERY = [
  { label: 'Rooftop lounge', tag: 'Ambiance', size: 'tall', accent: 'from-[#EED4D2] via-[#E0A4A9]/35 to-[#A8DAD4]/35' },
  { label: 'Chef plating', tag: 'Kitchen', size: 'square', accent: 'from-[#FAF1EA] via-[#D88F95]/30 to-[#EED4D2]' },
  { label: 'Cocktail bar', tag: 'Bar', size: 'wide', accent: 'from-[#A8DAD4]/40 via-[#F5DCDF] to-[#FAF1EA]' },
  { label: 'Garden terrace', tag: 'Outdoor', size: 'square', accent: 'from-[#E0A4A9]/35 via-[#FAF1EA] to-[#5C8F87]/22' },
  { label: 'Private dining', tag: 'Reserved', size: 'tall', accent: 'from-[#F5DCDF]/70 via-[#D88F95]/25 to-[#FAF1EA]' },
];

export const HOURS = [
  { day: 'Tue – Thu', time: '5:00 PM — 10:00 PM' },
  { day: 'Fri – Sat', time: '5:00 PM — 11:30 PM' },
  { day: 'Sunday', time: '5:00 PM — 10:00 PM' },
];

export const MARQUEE = ['Rooftop terrace', 'Seasonal menu', 'Live jazz · Fri & Sat', 'Sommelier on hand', 'Private dining', 'Chef Sora Nakamura'];
`,

  'src/components/Navbar.js': `import React, { useEffect, useState } from 'react';

const LINKS = [
  { label: 'Menu', href: '#menu' },
  { label: 'Experience', href: '#experience' },
  { label: 'Gallery', href: '#gallery' },
  { label: 'Journal', href: '#journal' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 32);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={'sticky top-0 z-50 transition-all duration-500 ' + (scrolled ? 'bg-[#F4ECE6]/85 backdrop-blur-xl border-b border-[#2A1F1B]/8' : 'bg-transparent')}>
      <div className="mx-auto grid max-w-[1320px] grid-cols-[auto_1fr_auto] items-center gap-6 px-6 py-5 md:px-10 md:py-6">
        <a href="#" className="flex items-center gap-3">
          <span className="font-editorial text-[26px] font-light italic leading-none text-[#2A1F1B]">Rosette</span>
          <span className="hidden h-7 w-px bg-[#2A1F1B]/25 sm:block" />
          <span className="hidden font-editorial text-[16px] font-light tracking-[0.32em] uppercase text-[#6F5D56] sm:inline">Terrace</span>
        </a>
        <nav className="hidden items-center justify-center gap-12 md:flex">
          {LINKS.map((l) => (
            <a key={l.label} href={l.href} className="text-[11px] font-medium uppercase tracking-[0.28em] text-[#2A1F1B]/70 transition-colors hover:text-[#C77F88]">
              {l.label}
            </a>
          ))}
        </nav>
        <a href="#reservations" className="rt-link">
          Reserve <span aria-hidden>&rarr;</span>
        </a>
      </div>
    </header>
  );
}
`,

  'src/components/Hero.js': `import React from 'react';

export default function Hero() {
  return (
    <section className="relative">
      <div className="absolute left-6 top-44 z-20 hidden md:block">
        <p className="rt-vertical-label text-[#6F5D56]">Spring · Vol 04 · MMXXVI</p>
      </div>

      <div className="mx-auto grid max-w-[1320px] grid-cols-12 gap-6 px-6 pt-8 md:px-10 md:pt-12">
        <div className="col-span-12 lg:col-span-7 rt-fade">
          <p className="rt-chapter text-[22px] md:text-[26px]">Chapter I — An invitation</p>
          <h1 className="font-editorial mt-10 text-[clamp(3.5rem,9vw,7.5rem)] font-light leading-[0.92] tracking-[-0.03em] text-[#2A1F1B]">
            <span className="block">Dinner,</span>
            <span className="block">at the edge</span>
            <span className="block italic font-normal text-[#C77F88]">of golden hour.</span>
          </h1>
          <div className="mt-10 grid max-w-xl grid-cols-[auto_1fr] items-start gap-x-8 gap-y-3 border-t border-[#2A1F1B]/15 pt-8">
            <p className="rt-eyebrow text-[#5C8F87]">Tonight</p>
            <p className="text-[15px] font-light leading-relaxed text-[#3A2D27]">
              A modern fine-dining lounge above the city — seasonal fusion cuisine, artisan cocktails, and a room designed to remember.
            </p>
            <p className="rt-eyebrow text-[#5C8F87]">Hours</p>
            <p className="text-[15px] font-light text-[#3A2D27]">Tue – Sun · 5:00 PM – 11:00 PM</p>
            <p className="rt-eyebrow text-[#5C8F87]">Address</p>
            <p className="text-[15px] font-light text-[#3A2D27]">88 Bloom Avenue · 14th floor</p>
          </div>
          <div className="mt-12 flex flex-wrap items-center gap-6">
            <a href="#reservations" className="btn-fill">Reserve your evening <span aria-hidden>&rarr;</span></a>
            <a href="#menu" className="rt-link">Read the menu</a>
          </div>
        </div>

        <div className="relative col-span-12 mt-12 lg:col-span-5 lg:mt-0">
          <div className="relative h-[640px] w-full overflow-hidden bg-gradient-to-br from-[#EED4D2] via-[#F5DCDF] to-[#A8DAD4]/55">
            <div className="absolute inset-0 bg-gradient-to-t from-[#2A1F1B]/45 via-transparent to-transparent" />
            <div className="absolute left-6 top-6 z-10 inline-flex items-center gap-2 bg-[#FFF8F2]/85 px-3 py-1.5 text-[10px] font-semibold uppercase tracking-[0.22em] text-[#2A1F1B] backdrop-blur">
              <span className="h-1.5 w-1.5 rounded-full bg-[#C77F88]" /> Live tonight
            </div>
            <div className="absolute bottom-0 left-0 right-0 z-10 p-8">
              <p className="rt-eyebrow text-[#FFF8F2]/85">Tonight&apos;s feature</p>
              <p className="font-editorial mt-2 text-[34px] font-light leading-[1.05] text-[#FFF8F2]">Citrus Cured Salmon</p>
              <p className="mt-2 max-w-xs text-[13px] font-light text-[#FFF8F2]/80">Avocado, ponzu gel, crispy shallot, edible petals.</p>
            </div>
          </div>
          <div className="absolute -bottom-8 -left-8 hidden border border-[#2A1F1B]/15 bg-[#F4ECE6] px-7 py-5 shadow-[0_24px_56px_rgba(42,31,27,0.18)] md:block">
            <p className="font-editorial text-[40px] font-light leading-none text-[#2A1F1B]">$98</p>
            <p className="mt-2 rt-eyebrow text-[#C77F88]">Chef&apos;s omakase</p>
          </div>
        </div>
      </div>

      <div className="mt-20 overflow-hidden border-y border-[#2A1F1B]/15 py-5">
        <div className="flex w-max animate-[rt-marquee_38s_linear_infinite] gap-12">
          {[...Array(2)].map((_, k) => (
            <div key={k} className="flex shrink-0 items-center gap-12">
              {['Rooftop terrace', 'Seasonal menu', 'Live jazz · Fri & Sat', 'Sommelier on hand', 'Private dining', 'Chef Sora Nakamura'].map((m) => (
                <span key={k + m} className="font-editorial flex items-center gap-12 text-[24px] font-light italic text-[#2A1F1B]">
                  {m} <span aria-hidden className="text-[#C77F88]">&#x2766;</span>
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
`,

  'src/components/FeaturedDishes.js': `import React from 'react';
import { DISHES } from '../data/restaurant';

export default function FeaturedDishes() {
  return (
    <section id="menu" className="relative px-6 py-28 md:px-10 md:py-40">
      <div className="mx-auto max-w-[1320px]">
        <div className="grid grid-cols-12 items-end gap-6">
          <div className="col-span-12 md:col-span-7">
            <p className="rt-chapter text-[22px]">Chapter II — Tonight&apos;s selection</p>
            <h2 className="font-editorial mt-6 text-[clamp(2.5rem,6vw,5rem)] font-light leading-[0.98] tracking-[-0.02em] text-[#2A1F1B]">
              Four plates, <span className="italic text-[#C77F88]">composed with intent.</span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-4 md:col-start-9">
            <p className="text-[14px] font-light leading-relaxed text-[#6F5D56]">
              Seasonal compositions from Chef Sora&apos;s kitchen, paired with cellar selections from our resident sommelier.
            </p>
            <a href="#full-menu" className="rt-link mt-6">View full menu</a>
          </div>
        </div>

        <div className="rt-rule mt-16" />

        <div className="mt-16 grid grid-cols-12 gap-x-6 gap-y-20">
          {DISHES.map((d, i) => {
            const odd = i % 2 === 0;
            return (
              <article
                key={d.name}
                className={
                  'group col-span-12 md:col-span-6 ' +
                  (odd ? 'lg:col-span-7' : 'lg:col-span-5 lg:translate-y-12')
                }
              >
                <div className="grid grid-cols-[auto_1fr] gap-8">
                  <div>
                    <span className="font-editorial text-[68px] font-light italic leading-none text-[#C77F88]/80">{d.number}</span>
                  </div>
                  <div>
                    <div className="flex items-center justify-between text-[10px] font-semibold uppercase tracking-[0.28em]">
                      <span className="text-[#5C8F87]">{d.course}</span>
                      <span className="text-[#C77F88]">{d.badge}</span>
                    </div>
                    <h3 className="font-editorial mt-3 text-[34px] font-light leading-[1.08] text-[#2A1F1B] md:text-[40px]">{d.name}</h3>
                    <p className="mt-4 max-w-md text-[14px] font-light leading-relaxed text-[#6F5D56]">{d.desc}</p>
                  </div>
                </div>
                <div className={'relative mt-8 h-[420px] overflow-hidden bg-gradient-to-br ' + d.accent}>
                  <div className="absolute inset-0 bg-gradient-to-t from-[#2A1F1B]/25 via-transparent to-transparent opacity-0 transition duration-500 group-hover:opacity-100" />
                  <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between">
                    <div>
                      <p className="rt-eyebrow text-[#2A1F1B]/50">Pairing</p>
                      <p className="font-editorial mt-1 text-[18px] font-light italic text-[#2A1F1B]">{d.pairing}</p>
                    </div>
                    <p className="font-editorial text-[56px] font-light leading-none text-[#2A1F1B]">\${d.price}</p>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
`,

  'src/components/Experience.js': `import React from 'react';

export default function Experience() {
  return (
    <section id="experience" className="relative overflow-hidden bg-[#2A1F1B] text-[#F4ECE6]">
      <div className="pointer-events-none absolute -right-32 top-1/4 h-[480px] w-[480px] rounded-full bg-[#C77F88]/25 blur-[120px]" />
      <div className="pointer-events-none absolute -left-32 bottom-0 h-[420px] w-[420px] rounded-full bg-[#5C8F87]/22 blur-[110px]" />

      <div className="relative mx-auto grid max-w-[1320px] grid-cols-12 gap-6 px-6 py-32 md:px-10 md:py-44">
        <div className="col-span-12 lg:col-span-5">
          <p className="rt-chapter text-[22px] !text-[#E0A4A9]">Chapter III — The room</p>
          <h2 className="font-editorial mt-8 text-[clamp(2.75rem,7vw,5.5rem)] font-light leading-[0.95] tracking-[-0.02em]">
            Candlelit.<br />
            Intimate.<br />
            <span className="italic text-[#E0A4A9]">Alive.</span>
          </h2>
          <p className="mt-10 max-w-md text-[15px] font-light leading-[1.85] text-[#F4ECE6]/75">
            Soft candlelight, curated playlists, and panoramic city views. An open kitchen invites you to witness the chef&apos;s artistry while you dine in a room designed to feel both cozy and cinematic.
          </p>
          <p className="mt-6 max-w-md text-[13px] font-light leading-[1.8] text-[#F4ECE6]/55">
            Chef Sora Nakamura — formerly of Eleven Madison and Narisawa — blends Pacific Rim flavor with European technique.
          </p>
          <div className="mt-12 flex flex-wrap items-center gap-6">
            <a href="#reservations" className="btn-fill !bg-[#F4ECE6] !text-[#2A1F1B] hover:!bg-[#E0A4A9] hover:!text-[#FFF8F2]">Book a table <span aria-hidden>&rarr;</span></a>
            <a href="#gallery" className="rt-link-soft !text-[#F4ECE6]/85 hover:!text-[#E0A4A9]">See the room</a>
          </div>
        </div>

        <div className="col-span-12 grid grid-cols-2 gap-4 lg:col-span-7 lg:grid-cols-[1.2fr_1fr] lg:gap-6">
          <div className="relative col-span-2 h-[420px] overflow-hidden bg-gradient-to-br from-[#EED4D2] via-[#E0A4A9]/55 to-[#5C8F87]/40 lg:col-span-1 lg:h-[520px]">
            <div className="absolute inset-0 bg-gradient-to-t from-[#2A1F1B]/50 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 right-6">
              <p className="rt-eyebrow text-[#F4ECE6]/70">Capacity</p>
              <p className="font-editorial mt-1 text-[40px] font-light leading-none text-[#F4ECE6]">68 seats</p>
            </div>
          </div>
          <div className="grid gap-4 lg:gap-6">
            <div className="relative h-[200px] overflow-hidden bg-gradient-to-br from-[#A8DAD4]/55 via-[#5C8F87]/40 to-[#2A1F1B] lg:h-[248px]">
              <div className="absolute inset-0 bg-gradient-to-t from-[#2A1F1B]/55 to-transparent" />
              <div className="absolute bottom-5 left-5">
                <p className="rt-eyebrow !text-[#F4ECE6]/70">Bar</p>
                <p className="font-editorial mt-1 text-[22px] font-light text-[#F4ECE6]">Cocktail lounge</p>
              </div>
            </div>
            <div className="relative h-[200px] overflow-hidden bg-gradient-to-br from-[#E0A4A9]/55 via-[#C77F88]/40 to-[#2A1F1B] lg:h-[248px]">
              <div className="absolute inset-0 bg-gradient-to-t from-[#2A1F1B]/55 to-transparent" />
              <div className="absolute bottom-5 left-5">
                <p className="rt-eyebrow !text-[#F4ECE6]/70">Outdoor</p>
                <p className="font-editorial mt-1 text-[22px] font-light text-[#F4ECE6]">Rooftop terrace</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
`,

  'src/components/MenuShowcase.js': `import React, { useState } from 'react';
import { MENU_CATEGORIES } from '../data/restaurant';

export default function MenuShowcase() {
  const [active, setActive] = useState(0);
  const current = MENU_CATEGORIES[active];

  return (
    <section className="relative px-6 py-32 md:px-10 md:py-44">
      <div className="mx-auto max-w-[1320px]">
        <div className="grid grid-cols-12 items-end gap-6">
          <div className="col-span-12 md:col-span-8">
            <p className="rt-chapter text-[22px]">Chapter IV — The menu</p>
            <h2 className="font-editorial mt-6 text-[clamp(2.5rem,6vw,5rem)] font-light leading-[0.98] tracking-[-0.02em] text-[#2A1F1B]">
              Composed like <span className="italic text-[#C77F88]">poetry.</span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-4">
            <p className="text-[14px] font-light leading-relaxed text-[#6F5D56]">
              Each section refreshes seasonally, guided by what the morning&apos;s market brings in.
            </p>
          </div>
        </div>

        <div className="rt-rule mt-16" />

        <div className="mt-16 grid grid-cols-12 gap-6">
          <div className="col-span-12 lg:col-span-7">
            <ul className="border-t border-[#2A1F1B]/15">
              {MENU_CATEGORIES.map((c, i) => {
                const isActive = active === i;
                return (
                  <li key={c.name}>
                    <button
                      type="button"
                      onClick={() => setActive(i)}
                      className={
                        'group grid w-full grid-cols-[64px_1fr_auto] items-center gap-6 border-b border-[#2A1F1B]/15 py-7 text-left transition duration-500 md:py-9 ' +
                        (isActive ? 'pl-2' : 'opacity-65 hover:opacity-100 hover:pl-2')
                      }
                    >
                      <span className={'font-editorial text-[26px] font-light italic transition ' + (isActive ? 'text-[#C77F88]' : 'text-[#6F5D56]')}>{c.roman}</span>
                      <div>
                        <h3 className={'font-editorial text-[34px] font-light leading-none tracking-[-0.01em] transition md:text-[44px] ' + (isActive ? 'text-[#2A1F1B]' : 'text-[#3A2D27]')}>{c.name}</h3>
                        <p className="mt-2 text-[12px] font-light text-[#6F5D56]">{c.tag}</p>
                      </div>
                      <span className="font-editorial text-[18px] font-light italic text-[#6F5D56]">{String(c.count).padStart(2, '0')}</span>
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>

          <aside className="col-span-12 lg:col-span-5 lg:pl-10">
            <div className="sticky top-32">
              <p className="rt-eyebrow text-[#5C8F87]">Now showing</p>
              <p className="font-editorial mt-4 text-[28px] font-light italic text-[#C77F88]">{current.roman}</p>
              <h3 className="font-editorial mt-4 text-[48px] font-light leading-[1.05] text-[#2A1F1B]">{current.name}</h3>
              <p className="mt-4 text-[14px] font-light leading-relaxed text-[#6F5D56]">{current.tag}</p>
              <div className="mt-10 grid grid-cols-2 gap-6 border-t border-[#2A1F1B]/15 pt-8">
                <div>
                  <p className="rt-eyebrow text-[#5C8F87]">Dishes</p>
                  <p className="font-editorial mt-2 text-[28px] font-light text-[#2A1F1B]">{current.count}</p>
                </div>
                <div>
                  <p className="rt-eyebrow text-[#5C8F87]">Updated</p>
                  <p className="font-editorial mt-2 text-[14px] font-light italic text-[#2A1F1B]">Spring 2026</p>
                </div>
              </div>
              <a href="#full-menu" className="rt-link mt-10">Explore section <span aria-hidden>&rarr;</span></a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}
`,

  'src/components/Reservation.js': `import React, { useState } from 'react';
import { HOURS } from '../data/restaurant';

export default function Reservation() {
  const [form, setForm] = useState({ date: '', time: '', guests: '2', name: '', email: '' });

  return (
    <section id="reservations" className="relative px-6 py-32 md:px-10 md:py-44">
      <div className="mx-auto max-w-[1320px]">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 lg:col-span-7">
            <p className="rt-chapter text-[22px]">Chapter V — Reservations</p>
            <h2 className="font-editorial mt-8 text-[clamp(3rem,9vw,8rem)] font-light leading-[0.88] tracking-[-0.03em] text-[#2A1F1B]">
              Reserve<br />
              <span className="italic text-[#C77F88]">the evening.</span>
            </h2>
            <p className="mt-10 max-w-md text-[15px] font-light leading-[1.85] text-[#6F5D56]">
              Rooftop tables fill quickly. Book ahead for sunset seating or weekend reservations. Our concierge confirms within the hour.
            </p>
            <div className="mt-12 grid max-w-md grid-cols-[auto_1fr] gap-x-8 gap-y-4 border-t border-[#2A1F1B]/15 pt-10">
              {HOURS.map((h) => (
                <React.Fragment key={h.day}>
                  <p className="rt-eyebrow text-[#5C8F87]">{h.day}</p>
                  <p className="text-[14px] font-light text-[#2A1F1B]">{h.time}</p>
                </React.Fragment>
              ))}
              <p className="rt-eyebrow text-[#5C8F87]">Phone</p>
              <p className="text-[14px] font-light text-[#2A1F1B]">(415) 555 — 0188</p>
            </div>
          </div>

          <form className="col-span-12 lg:col-span-5 lg:pl-8" onSubmit={(e) => e.preventDefault()}>
            <div className="border border-[#2A1F1B]/15 bg-[#FFF8F2]/70 p-8 backdrop-blur md:p-10">
              <p className="rt-eyebrow text-[#C77F88]">Book a table</p>
              <h3 className="font-editorial mt-3 text-[28px] font-light leading-tight text-[#2A1F1B]">Begin your reservation</h3>

              <div className="mt-8 space-y-7">
                <div className="grid grid-cols-2 gap-5">
                  <div>
                    <label className="rt-eyebrow !text-[10px] text-[#6F5D56]">Date</label>
                    <input type="date" value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} className="mt-2 w-full border-0 border-b border-[#2A1F1B]/30 bg-transparent py-2 font-editorial text-[18px] text-[#2A1F1B] outline-none transition focus:border-[#C77F88]" />
                  </div>
                  <div>
                    <label className="rt-eyebrow !text-[10px] text-[#6F5D56]">Time</label>
                    <select value={form.time} onChange={(e) => setForm({ ...form, time: e.target.value })} className="mt-2 w-full border-0 border-b border-[#2A1F1B]/30 bg-transparent py-2 font-editorial text-[18px] text-[#2A1F1B] outline-none transition focus:border-[#C77F88]">
                      <option value="">7:00 PM</option>
                      <option value="17:00">5:00 PM</option>
                      <option value="18:00">6:00 PM</option>
                      <option value="19:00">7:00 PM</option>
                      <option value="20:00">8:00 PM</option>
                      <option value="21:00">9:00 PM</option>
                    </select>
                  </div>
                </div>
                <div>
                  <label className="rt-eyebrow !text-[10px] text-[#6F5D56]">Guests</label>
                  <select value={form.guests} onChange={(e) => setForm({ ...form, guests: e.target.value })} className="mt-2 w-full border-0 border-b border-[#2A1F1B]/30 bg-transparent py-2 font-editorial text-[18px] text-[#2A1F1B] outline-none transition focus:border-[#C77F88]">
                    {[1, 2, 3, 4, 5, 6, 7, 8].map((n) => (
                      <option key={n} value={n}>{n} guest{n > 1 ? 's' : ''}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="rt-eyebrow !text-[10px] text-[#6F5D56]">Name</label>
                  <input type="text" placeholder="Your name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-2 w-full border-0 border-b border-[#2A1F1B]/30 bg-transparent py-2 font-editorial text-[18px] text-[#2A1F1B] outline-none transition placeholder:text-[#B8AFA8] focus:border-[#C77F88]" />
                </div>
                <div>
                  <label className="rt-eyebrow !text-[10px] text-[#6F5D56]">Email</label>
                  <input type="email" placeholder="you@email.com" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-2 w-full border-0 border-b border-[#2A1F1B]/30 bg-transparent py-2 font-editorial text-[18px] text-[#2A1F1B] outline-none transition placeholder:text-[#B8AFA8] focus:border-[#C77F88]" />
                </div>
              </div>

              <button type="submit" className="btn-fill mt-10 w-full justify-center">
                Confirm reservation <span aria-hidden>&rarr;</span>
              </button>
              <p className="mt-4 text-center text-[11px] font-light text-[#6F5D56]">Cancellations welcomed up to 24 hours before service.</p>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}
`,

  'src/components/Testimonials.js': `import React from 'react';
import { TESTIMONIALS } from '../data/restaurant';

export default function Testimonials() {
  const [hero, ...rest] = TESTIMONIALS;

  return (
    <section className="relative bg-[#EED4D2]/35 px-6 py-32 md:px-10 md:py-44">
      <div className="mx-auto max-w-[1320px]">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-3">
            <p className="rt-chapter text-[22px]">Chapter VI</p>
            <p className="rt-eyebrow mt-4 text-[#5C8F87]">Guest stories</p>
            <p className="mt-10 text-[13px] font-light leading-relaxed text-[#6F5D56]">
              4.9 / 5 across 1,200+ verified diners on OpenTable, Resy &amp; Google.
            </p>
          </div>
          <div className="col-span-12 md:col-span-9">
            <blockquote>
              <p className="font-editorial text-[clamp(2rem,4.6vw,3.4rem)] font-light italic leading-[1.18] tracking-[-0.015em] text-[#2A1F1B]">
                &ldquo;{hero.quote}&rdquo;
              </p>
              <footer className="mt-10 flex items-center gap-4 border-t border-[#2A1F1B]/15 pt-8">
                <div className="h-12 w-12 rounded-full bg-gradient-to-br from-[#E0A4A9] via-[#C77F88] to-[#5C8F87]" />
                <div>
                  <p className="font-editorial text-[18px] font-light text-[#2A1F1B]">{hero.name}</p>
                  <p className="mt-1 text-[11px] uppercase tracking-[0.22em] text-[#6F5D56]">{hero.role}</p>
                </div>
              </footer>
            </blockquote>
          </div>
        </div>

        <div className="rt-rule mt-20" />

        <div className="mt-16 grid grid-cols-12 gap-6">
          {rest.map((t, i) => (
            <blockquote key={t.name} className={'col-span-12 md:col-span-6 ' + (i === 1 ? 'md:translate-y-12' : '')}>
              <p className="rt-eyebrow text-[#C77F88]">{'\u2605'.repeat(t.rating)}</p>
              <p className="font-editorial mt-6 text-[20px] font-light italic leading-[1.55] text-[#3A2D27] md:text-[22px]">&ldquo;{t.quote}&rdquo;</p>
              <footer className="mt-8 border-t border-[#2A1F1B]/15 pt-6">
                <p className="font-editorial text-[16px] font-light text-[#2A1F1B]">{t.name}</p>
                <p className="mt-1 text-[10px] uppercase tracking-[0.22em] text-[#6F5D56]">{t.role}</p>
              </footer>
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
`,

  'src/components/Gallery.js': `import React from 'react';
import { GALLERY } from '../data/restaurant';

export default function Gallery() {
  return (
    <section id="gallery" className="relative px-6 py-32 md:px-10 md:py-44">
      <div className="mx-auto max-w-[1320px]">
        <div className="grid grid-cols-12 items-end gap-6">
          <div className="col-span-12 md:col-span-8">
            <p className="rt-chapter text-[22px]">Chapter VII — In the room</p>
            <h2 className="font-editorial mt-6 text-[clamp(2.5rem,6vw,5rem)] font-light leading-[0.98] tracking-[-0.02em] text-[#2A1F1B]">
              A feast for the <span className="italic text-[#C77F88]">eyes.</span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-4">
            <p className="text-[13px] font-light leading-relaxed text-[#6F5D56]">
              Follow <span className="font-medium text-[#C77F88]">@rosetteterrace</span> for daily inspiration from the kitchen and rooftop.
            </p>
            <a href="#instagram" className="rt-link mt-6">View Instagram</a>
          </div>
        </div>

        <div className="rt-rule mt-14" />

        <div className="mt-12 grid grid-cols-12 gap-4 md:gap-6">
          {GALLERY.map((item, i) => {
            const layout =
              item.size === 'tall'
                ? 'col-span-12 sm:col-span-6 lg:col-span-4 row-span-2 h-[480px]'
                : item.size === 'wide'
                  ? 'col-span-12 lg:col-span-8 h-[300px]'
                  : 'col-span-6 lg:col-span-4 h-[240px]';
            return (
              <figure key={item.label} className={'group relative overflow-hidden ' + layout}>
                <div className={'absolute inset-0 bg-gradient-to-br ' + item.accent} />
                <div className="absolute inset-0 bg-gradient-to-t from-[#2A1F1B]/55 via-transparent to-transparent opacity-0 transition duration-500 group-hover:opacity-100" />
                <figcaption className="absolute bottom-5 left-5 right-5">
                  <p className="rt-eyebrow !text-[#2A1F1B]/55 transition group-hover:!text-[#FFF8F2]/85">{item.tag}</p>
                  <p className={'font-editorial mt-1 text-[22px] font-light leading-tight text-[#2A1F1B] transition group-hover:text-[#FFF8F2] ' + (i === 0 ? 'md:text-[28px]' : '')}>{item.label}</p>
                </figcaption>
                <span className="absolute right-4 top-4 text-[10px] font-semibold uppercase tracking-[0.24em] text-[#2A1F1B]/55">0{i + 1}</span>
              </figure>
            );
          })}
        </div>
      </div>
    </section>
  );
}
`,

  'src/components/Newsletter.js': `import React, { useState } from 'react';

export default function Newsletter() {
  const [email, setEmail] = useState('');

  return (
    <section className="relative px-6 py-32 md:px-10 md:py-40">
      <div className="mx-auto max-w-[1320px]">
        <div className="grid grid-cols-12 items-end gap-6 border-y border-[#2A1F1B]/15 py-16 md:py-24">
          <div className="col-span-12 md:col-span-7">
            <p className="rt-chapter text-[22px]">Chapter VIII — The journal</p>
            <h2 className="font-editorial mt-6 text-[clamp(2.25rem,5vw,4rem)] font-light leading-[1] tracking-[-0.02em] text-[#2A1F1B]">
              Join our <span className="italic text-[#C77F88]">culinary circle.</span>
            </h2>
            <p className="mt-6 max-w-md text-[14px] font-light leading-relaxed text-[#6F5D56]">
              Exclusive events, seasonal menus, and reservation priority — delivered to your inbox once a month.
            </p>
          </div>
          <form className="col-span-12 md:col-span-5" onSubmit={(e) => e.preventDefault()}>
            <div className="flex items-end gap-4 border-b border-[#2A1F1B]/40 pb-2">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your email address"
                className="flex-1 border-0 bg-transparent py-2 font-editorial text-[20px] font-light text-[#2A1F1B] outline-none placeholder:text-[#B8AFA8] md:text-[22px]"
              />
              <button type="submit" className="rt-link border-b-0 pb-0">Subscribe <span aria-hidden>&rarr;</span></button>
            </div>
            <p className="mt-3 text-[11px] font-light text-[#6F5D56]">One letter a month. Unsubscribe anytime.</p>
          </form>
        </div>
      </div>
    </section>
  );
}
`,

  'src/components/Footer.js': `import React from 'react';

const COLS = [
  { title: 'Visit', links: ['Hours & Location', 'Private Events', 'Gift Cards'] },
  { title: 'Discover', links: ['Our Story', "Chef's Table", 'Wine List'] },
  { title: 'Connect', links: ['Instagram', 'Reservations', 'Contact'] },
];

export default function Footer() {
  return (
    <footer className="relative bg-[#2A1F1B] px-6 py-24 text-[#F4ECE6] md:px-10 md:py-32">
      <div className="mx-auto max-w-[1320px]">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 lg:col-span-5">
            <p className="font-editorial text-[clamp(3rem,7vw,5.5rem)] font-light leading-none text-[#F4ECE6]">
              Rosette
            </p>
            <p className="font-editorial mt-2 text-[clamp(1.5rem,3vw,2.25rem)] font-light italic leading-none text-[#E0A4A9]">
              Terrace
            </p>
            <p className="mt-10 max-w-xs text-[14px] font-light leading-[1.75] text-[#F4ECE6]/65">
              Modern rooftop dining &amp; lounge at the intersection of flavor and atmosphere. 88 Bloom Avenue, Downtown.
            </p>
            <p className="mt-6 rt-eyebrow !text-[#E0A4A9]">Tue – Sun &middot; 5:00 PM – 11:00 PM</p>
          </div>
          <div className="col-span-12 grid grid-cols-3 gap-6 lg:col-span-7 lg:pl-10">
            {COLS.map((col) => (
              <div key={col.title}>
                <h4 className="rt-eyebrow !text-[#E0A4A9]">{col.title}</h4>
                <ul className="mt-8 space-y-4">
                  {col.links.map((link) => (
                    <li key={link}>
                      <a
                        href={'#' + link.toLowerCase().replace(/\\s/g, '-').replace(/'/g, '')}
                        className="font-editorial text-[18px] font-light text-[#F4ECE6]/80 transition hover:text-[#E0A4A9]"
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-24 flex flex-col items-start justify-between gap-6 border-t border-[#F4ECE6]/15 pt-10 sm:flex-row sm:items-center">
          <p className="text-[12px] font-light tracking-[0.12em] text-[#F4ECE6]/55">&copy; 2026 Rosette Terrace &middot; Crafted with love</p>
          <div className="flex gap-8">
            {['Instagram', 'TikTok', 'OpenTable'].map((s) => (
              <a key={s} href={'#' + s.toLowerCase()} className="text-[11px] font-semibold uppercase tracking-[0.24em] text-[#F4ECE6]/65 transition hover:text-[#E0A4A9]">
                {s}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
`,
};
